import { alpha, type SxProps, type Theme } from "@mui/material";

import { fernieColors } from "~/themes/fernieBrand";

export const FERNIE_HOVER_GLOW_COLOR = fernieColors.led;

export const fernieHoverGlowSx = {
	"@media (hover: hover)": {
		"&:hover": { boxShadow: `0 0 6px ${alpha(fernieColors.led, 0.55)}` },
		transition: "box-shadow 150ms ease-in-out"
	},
	"@media (prefers-reduced-motion: reduce)": {
		"&:hover": { boxShadow: `0 0 4px ${alpha(fernieColors.led, 0.45)}` },
		transition: "none"
	}
} satisfies SxProps<Theme>;
